import { z } from "zod";

const categorieIdSchema = z.number();

export const getCategorieSchema = z.object({
  categoryId: categorieIdSchema,
  categoryName: z.string(),
});
export const getCategoriesSchema = z.array(getCategorieSchema);

export type GetCategoriesType = z.infer<typeof getCategoriesSchema>;
